import { render, staticRenderFns } from "./PurchaseReceivingEdit.vue?vue&type=template&id=1c1790c6&"
import script from "./PurchaseReceivingEdit.vue?vue&type=script&lang=js&"
export * from "./PurchaseReceivingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports